// extracted by mini-css-extract-plugin
export default {"container":"_0jkFZL","button":"So31Qq","icon":"Xsg3Nv","text":"eOrUiU","title":"qImnNv","info":"YFCEUJ"};